import React from "react";
import { useNavigate } from "react-router-dom";
import "./ApplePay.css";

export default function ApplePay() {
  const navigate = useNavigate();
  return (
    <div className="info-page">
      {/* Header */}
      <div className="info-header">
        <button className="info-back" onClick={() => navigate("/card")}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <span className="info-title">Apple Pay</span>
        <span style={{width:22}}/>
      </div>

      {/* Hero */}
      <div className="info-hero ap-hero">
        <div className="ap-apple-icon">
          <svg width="42" height="42" viewBox="0 0 24 24" fill="white">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
        </div>
        <h2 className="ap-hero-title">Apple Pay</h2>
        <p className="ap-hero-sub">Add your eToro Visa to Apple Wallet and pay with Face ID or Touch ID — no card needed.</p>

        {/* Wallet mockup */}
        <div className="ap-wallet-mock">
          <div className="ap-wallet-label">APPLE WALLET</div>
          <div className="ap-wallet-card">
            <div>
              <div className="ap-wc-name">eToro Visa</div>
              <div className="ap-wc-num">•••• 4242</div>
            </div>
            <span className="ap-wc-visa">VISA</span>
          </div>
          <div className="ap-wallet-badge">✓ Ready to add</div>
        </div>
      </div>

      {/* Steps */}
      <div className="info-steps-wrap">
        <div className="info-section-label">HOW TO ADD YOUR CARD</div>

        <div className="info-step">
          <div className="info-step-num">1</div>
          <div className="info-step-body">
            <div className="info-step-title">Open the Wallet app</div>
            <div className="info-step-desc">On your iPhone, open the Wallet app and tap the <strong style={{color:"#f0f2f5"}}>+</strong> button in the top right corner.</div>
          </div>
        </div>
        <div className="info-step">
          <div className="info-step-num">2</div>
          <div className="info-step-body">
            <div className="info-step-title">Select "Debit or Credit Card"</div>
            <div className="info-step-desc">Choose to add a new card and select "Debit or Credit Card" from the options presented.</div>
          </div>
        </div>
        <div className="info-step">
          <div className="info-step-num">3</div>
          <div className="info-step-body">
            <div className="info-step-title">Scan or enter your card</div>
            <div className="info-step-desc">Point your camera at your eToro Visa card to scan it automatically, or enter the details manually.</div>
          </div>
        </div>
        <div className="info-step">
          <div className="info-step-num">4</div>
          <div className="info-step-body">
            <div className="info-step-title">Verify &amp; done</div>
            <div className="info-step-desc">Confirm your card details and complete verification. Your card is ready to use anywhere Apple Pay is accepted.</div>
          </div>
        </div>
      </div>

      <div className="info-note">
        <span className="info-note-icon">💡</span>
        <span className="info-note-text">Tap "Add to Apple Wallet" below — it will launch the Wallet app with your card details pre-filled.</span>
      </div>

      <div className="info-actions">
        <button className="info-btn-primary ap-wallet-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="white" style={{marginRight:8,verticalAlign:"middle"}}>
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
          </svg>
          Add to Apple Wallet
        </button>
        <button className="info-btn-outline" onClick={() => navigate("/card")}>← Back to Card</button>
      </div>
    </div>
  );
}
